import moment from 'moment';
import PdfMake from "pdfmake/build/pdfmake";
import PdfFonts from "pdfmake/build/vfs_fonts";
import { toTitleCase, formatAmountValueToString, getYear } from './LogicHelper';

const pdfGenerateReceipt = async (data, details, organisation) => {
    PdfMake.vfs = PdfFonts.vfs;
    PdfMake.fonts = {
      Roboto: {
        normal: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Regular.ttf',
        bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
        italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
      }
    }
  
    const {source, destination, scheduled_date, user, trip_type, quote, reference} = data;
    const {first_name, last_name, email, phone} = user || {};
    const {name} = organisation;
  
    const docDefinition = {
      pageOrientation: "portrait",
  
      footer: {
        columns: [
          {
            columns: [
              {
                alignment: 'left',
                style: "footer",
                text: `${name} - \u00A9 ${getYear()}`
              }
            ],
          }
        ],
      },
  
      content: [
        {
          columns: [
            {
              text: `${name.toUpperCase()}`,
              style: "logo"
            },
            {
              text: "RECEIPT",
              style: "title"
            },
          ],
        },
        {
          columns: [
            {
              columns: [
                {
                  text: "REFERENCE \u200B \n \n DATE",
                  width: 100,
                  style: "infoNude",
                },
                {
                  text: reference + "\n \n" + moment(scheduled_date).format('Do MMMM YYYY'),
                  width: 250,
                  style: "info",
                },
              ],
            }
          ],
        },
        {
          text: "Customer Information",
          style: "subheader",
        },
        {
          canvas: [{type: "line", x1: 0, y1: 0, x2: 595 - 2 * 40, y2: 0, lineWidth: 0.2}],
          style: "pretext",
        },
        {
          columns: [
            {
              text: "Customer",
              width: 300,
              style: "infoNude",
            }
          ],
        },
        {
          columns: [
            {
              text: `${first_name ? toTitleCase(first_name) : "-"} ${last_name ? toTitleCase(last_name) : "-"}`,
              width: 300,
              style: "info",
            },
          ],
        },
        {
          columns: [
            {
              text: "Email",
              width: 300,
              style: "infoNude",
            },
            {
              text: "Phone Number",
              width: 300,
              style: "infoNude",
            },
          ],
        },
        {
          columns: [
            {
              text: `${email ? email.toLowerCase() : "-"}`,
              width: 300,
              style: "info",
            },
            {
              text: `${phone ? phone : "-"}`,
              width: 300,
              style: "info",
            },
          ],
        },
        {
          columns: [
            {
              text: "Trip Type",
              width: 300,
              style: "infoNude",
            },
            {
              text: "Estimated Value of Item",
              width: 300,
              style: "infoNude",
            }
          ],
        },
        {
          columns: [
            {
              text: trip_type,
              width: 300,
              style: "info",
            },
            {
              text: `${quote['currency'] ? quote['currency'] : "NGN"} ${quote.estimated_value ? formatAmountValueToString(quote.estimated_value) : "0.00"}`,
              width: 300,
              style: "info",
            }
          ],
        },
        {
          text: "Trip Information",
          style: "subheader",
        },
        {
          canvas: [{type: "line", x1: 0, y1: 0, x2: 595 - 2 * 40, y2: 0, lineWidth: 0.2}],
          style: "pretext",
        },
        {
          columns: [
            {
              text: "Pickup location",
              width: 300,
              style: "infoNude",
            },
            {
              text: "Drop off location",
              width: 300,
              style: "infoNude",
            },
          ],
        },
        {
          columns: [
            {
              text: source.address,
              width: 300,
              style: "info",
            },
            {
              text: destination.address,
              width: 250,
              style: "info",
            },
          ],
        },
        {
          text: "Charges and Billing",
          style: "subheader",
        },
        {
          canvas: [{type: "line", x1: 0, y1: 0, x2: 595 - 2 * 40, y2: 0, lineWidth: 0.2}],
          style: "pretext",
        },
        {
          table: {
            headerRows: 0,
            heights: 30,
            widths: [300, 250],
            body: details,
          },
          layout: 'noBorders',
          style: "tableBody"
        },
        {
          canvas: [{type: "line", x1: 0, y1: 0, x2: 595 - 2 * 40, y2: 0, lineWidth: 0.2}],
          style: "pretext"
        },
        {
          columns: [
            {
              text: "Total Amount",
              width: 300,
              style: "infoBold",
            },
            {
              text: `${quote['currency'] ? quote['currency']  : "NGN"} ${quote['charge'] ? formatAmountValueToString(quote['charge']) : "0.00"}`,
              width: 300,
              style: "infoBold",
            },
          ],
        }
      ],
  
      defaultStyle: {
        font: 'Roboto'
      },
  
      styles: {
        title: {
          fontSize: 30,
          font: "Roboto",
          bold: true,
          margin: [0, 0, 0, 10],
          alignment: "right",
        },
        logo: {
          fontSize: 30,
          font: "Roboto",
          bold: true,
          margin: [0, 0, 0, 10],
          alignment: "left",
        },
        header: {
          fontSize: 16,
          bold: true,
          margin: [0, 20],
          alignment: "left",
        },
        subheader: {
          fontSize: 12,
          bold: true,
          margin: [0, 40, 0, 10],
          alignment: "left",
        },
        pretext: {
          margin: [0, 0, 0, 10],
          alignment: "left",
        },
        infoNude: {
          color: "#696969",
          fontSize: 9,
          margin: [0, 10, 0, 0],
          bold: true,
          alignment: "left",
        },
        infoBold: {
          color: "black",
          fontSize: 10,
          bold: true,
          margin: [0, 10, 0, 0],
          alignment: "left",
        },
        info: {
          color: "black",
          fontSize: 9,
          margin: [0, 10, 0, 0],
          alignment: "left",
        },
        tableBody: {
          fontSize: 10,
          alignment: "left"
        },
        footer: {
          color: "#696969",
          fontSize: 8,
          alignment: "left",
          margin: [30, 20, 0, 0]
        },
      },
    };
  
    PdfMake.createPdf(docDefinition).open();
  };

export default pdfGenerateReceipt